module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "element element-bodymatter element-container-single element-type-chapter element-with-heading",
    attrs: {
      "epub:type": "chapter",
      "id": "unnumbered-1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image"
  }, [_c('div', {
    staticClass: "heading-contents"
  }, [_c('div', {
    staticClass: "title-subtitle-block title-block-without-element-number"
  }, [_c('div', {
    staticClass: "element-number-block"
  }), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('h1', {
    staticClass: "element-title case-mixed"
  }, [_vm._v("Establishing Intimacy")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "text",
    attrs: {
      "id": "unnumbered-1-text"
    }
  }, [_c('div', {
    staticClass: "blockquote-container prose without-attribution within-prose-element"
  }, [_c('blockquote', {
    staticClass: "prose without-attribution within-prose-element"
  }, [_c('p', {
    staticClass: "first blockquote-content blockquote-content-prose blockquote-position-first"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("It was the murky, early days of online dating, when people were still suspicious of the ‘desperate’ few who met that way, intensifying the need for secrecy. It was difficult for her to remember not having instantaneous access to everything, but nobody did back then and sending and receiving emails was a novelty rather than a chore or an intrusion.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("They had exchanged hundreds of them, then instant messages, then texts, before she finally agreed to meet him face to face, in a remote pub car park, without telling anyone else, against all the warnings about where was safe for young women to meet strangers. But he wasn’t a stranger by then. The intimacy had been established and embedded through affectionate terms of endearments and she wasn’t afraid in the slightest. Quite the opposite, in fact.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("He was tall, dark, handsome and well built – skinny men didn’t do it for her at all – and wore designer labels, a black leather jacket and a black cap to their arranged rendezvous. A wolf in wolf’s clothing.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("‘Hello, m’lady,’ he said, grinning, using the title he had created for her, verbally branding her as his straight away. He was sexy as hell, and she knew immediately she was hopelessly infatuated.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("Their first date didn’t end. Those first few hours merged seamlessly into several nights and days in a row. It happened as naturally as a developing photograph, their relationship gaining clarity with each passing moment until they were frozen in time, perfect for ever. Or so she thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("She couldn’t have been more wrong.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("A few years later she finally fled from danger, from him, yet she was still trapped within the fragile yet impenetrable shell of the person she had become. That he had made her. He had poisoned her life more effectively than arsenic.")])]), _vm._v(" "), _c('p', {
    staticClass: "subsq blockquote-content blockquote-content-prose blockquote-position-last"
  }, [_c('span', {
    staticClass: "sans-serif"
  }, [_vm._v("— "), _c('i', [_vm._v("Descent into Deceit")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a526e2ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/establishing-intimacy.vue
// module id = 78
// module chunks = 0